export default __webpack_public_path__ + "static/media/RabbitHoles-reduced.f6f8432d.jpg";